import React from "react";
import { Merchant } from "../graphql/schema/merchant";
import { Supplier } from "src/graphql/codegen_graphql";

export const ContextUser = React.createContext<{
  merchant: Merchant & {
    supplier: Supplier | null;
    orderCount: number;
    TO_PREPARE: number;
    PREPARED: number;
    REQUESTED_PICKUP: number;
    READY: number;
  };
}>({
  merchant: {
    id: 0,
    name: "",
    role: "",
    logo: "",
    banner: "",
    address: "",
    balance: "",
    contact: "",
    origin: "",
    emails: "",
    userType: "None",
    supplier: null,
    TO_PREPARE: 0,
    PREPARED: 0,
    REQUESTED_PICKUP: 0,
    READY: 0,
    orderCount: 0,
  },
});
